import { ErrorHandler, Injectable, OnInit } from "@angular/core";
import { LoggingService } from "../logging.service";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class NetworkLoggerService implements HttpInterceptor {

    constructor(private logger: LoggingService) {
    }

    private createNetworkPayload(req: HttpRequest<any>, event: HttpResponse<any> | HttpErrorResponse,  startTime: number) {
        const duration = Date.now() - startTime;
        return {
            method: req.method,
            url: req.url,
            status: event.status,
            duration: duration
        };
    }

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime = Date.now();

    return next.handle(req).pipe(
      tap({
        // 1. Handle Successful Responses
        next: (event) => {
          if (event instanceof HttpResponse) {
            this.logger.logNetwork(this.createNetworkPayload(req, event, startTime));
          }
        },
        // 2. Handle API Errors (404, 500, Offline)
        error: (error: HttpErrorResponse) => {
          const duration = Date.now() - startTime;
          this.logger.logError({
            context: 'NETWORK_ERROR',
            message: error.message,
            stack: error.error?.stack || '',
            network: this.createNetworkPayload(req, error, startTime)
          });
        }
      })
    );
  }
}
